export enum EnumAutomationRunStatus {
  Running = 'running',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Cancelled = 'cancelled',
  Skipped = 'skipped',
  Unknown = 'unknown'
}
